
import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import { fetchList, mark, repurchase} from '@/api/pcm/unable-purchase';
import moment from "moment";
import {Message} from "element-ui";

export default extend(table, {
	namespaced: true,
	state: {
		searchForm: {
			searchType: ''
		},
		list: []
	},
	actions: {
		async getList({state, dispatch}, payload) {
			await wait(dispatch, 'pcm.unable-purchase.list', async function () {
				const {searchForm} = state;
				const startTime = searchForm.time && searchForm.time[0] && Math.round(moment(searchForm.time[0]).startOf('day').valueOf() / 1000)
				const endTime = searchForm.time && searchForm.time[1] && Math.round(moment(searchForm.time[1]).startOf('day').valueOf() / 1000)
				await dispatch('getData', {
					caller: fetchList,
					options: {
						...searchForm,
						time: null,
						startTime,
						endTime,
						...payload,
					}
				})
			})
		},
		async markPurchaseAction({ state, dispatch }, payload) {
			await wait(dispatch, 'pcm.unable-purchase.mark', async function() {
				await mark(payload);
				Message.success('操作成功');
			})
			dispatch('getList')
		},
		async rePurchaseAction({ state, dispatch }, payload) {
			await wait(dispatch, 'pcm.unable-purchase.repurchase', async function() {
				await repurchase(payload);
				Message.success('操作成功');
			})
			dispatch('getList')
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/pcm/unable-purchase/list.js